import React, {Component} from "react";
import app_cs from "./home.module.css";
import './home.css'
import $ from 'jquery'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onOff : true
        }
    }

    shareClick(){
        if(this.state.onOff){
            $('#social_icons-magic').css('left','25px')
            this.setState({
                onOff : false
            })
        }else{
            $('#social_icons-magic').css('left','0')
            this.setState({
                onOff : true
            })
        }
        $('#social_icons').toggleClass(app_cs['active'])
    }

    genarateScroll(){
        let result =[];

        //mostly change these two
        // let _picWidth =2640;
        let _picWidth =3660;
        let _z =(_picWidth/(2*Math.PI));


        let _n =60;
        let _ybasicDegree = 360/_n;
        let _pieceWidth = Math.ceil(_picWidth/_n);

        // result.push(  <div className={app_cs[0]} key={0} style={{width:`${_pieceWidth+1}px`, backgroundPosition:'0 0',transform:`rotateY(0deg) translateZ(${_z}px)`}}> </div>)
        for(let i=0;i<_n;i++){
            let _backgroundPosition = ((_picWidth) -(i)* _pieceWidth);
            let _y = _ybasicDegree*i;
            result.push(
                <div className={app_cs['pieceWrapper']} key={i}>
                    <div className={app_cs['pieceMain']}  style={{width:`${_pieceWidth+1}px`,backgroundPosition:`${_backgroundPosition}px 0`,transform:`rotateY(${_y}deg) translateZ(${_z}px)`}}> </div>
                    <div className={app_cs["pieceShadow"]}  style={{width:`${_pieceWidth}px`,height:'13px',transform:`rotateY(${_y}deg) translateZ(${_z}px)`}}></div>
                    <div className={app_cs['pieceDown']}  style={{width:`${_pieceWidth}px`,backgroundPosition:`${_backgroundPosition}px 0`,transform:`rotateY(${_y}deg) translateZ(${_z}px) scaleY(-1) `}}> </div>
                </div>
            )
        }
        return result;

    }

    render() {
        return (
            <section className={app_cs['home-wrapper']}>
                <div className={app_cs["shadow_people"]}></div>

                <div className={app_cs['home-container']}>
                    <div id="container" className={app_cs['container']}>
                        <div className={app_cs['frame']}>
                            <div className={app_cs['strip']} style={{animation: 'spin 25s infinite linear'}} >
                                {this.genarateScroll()}
                            </div>
                        </div>
                    </div>
                    <div className={app_cs['home-right']}>
                        <div className={app_cs['home-right-title']}>
                            俄乌历史经纬
                        </div>
                        <div className={app_cs['home-right-content']}>
                        历史事件的原因是一切原因的总和，这是唯一的原因。
                                    ——《战争与和平》
                        </div>
                        <div className={app_cs["pc-scroll-animation"]}>
                            <div className={app_cs["pc-scroll-line"]}></div>
                            <div>向下滑动，探索更多</div>
                            {/* <div>project</div> */}
                            <div className={app_cs["pc-scroll"]}>
                                <div className={app_cs["pc-scroll-content"]}></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={app_cs['home-timeline']}></div>

                {/*<div className={app_cs["share-box"]} >*/}
                {/*    <div ><img id="share_btn" onClick={()=>this.shareClick()}  className={app_cs["share-btn"]} src={require("assets/images/pc/share/share-btn.png")} alt="Share" /></div>*/}
                {/*    <div id="social_icons-magic" className={app_cs["social-icons-magic"]}></div>*/}
                {/*    <div id="social_icons" className={app_cs["social-icons"]}>*/}
                {/*        <a className={app_cs["share-fb"]} target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>*/}
                {/*        <a className={app_cs["share-twitter"]} target="_blank" href="https://twitter.com/intent/tweet?text=Historical Map: Ukraine Crisis&url=https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>*/}
                {/*        <a className={app_cs["share-sina"]} target="_blank" href="http://service.weibo.com/share/share.php?appkey=4122844478&title=Historical Map: Ukraine Crisis&url=https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </section>
        )
    }
}

export default App;